import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const CriteoPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.criteoAccountId) return null

    return (
        <Script
            id="criteo-pixel"
            src={`//dynamic.criteo.com/js/ld/ld.js?a=${landingPage.integrations.criteoAccountId}`}
            strategy="afterInteractive"
            async
        />
    )
}
